import { render, staticRenderFns } from "./Approvals.vue?vue&type=template&id=5f65e37a&scoped=true&"
import script from "./Approvals.vue?vue&type=script&lang=js&"
export * from "./Approvals.vue?vue&type=script&lang=js&"
import style0 from "./Approvals.vue?vue&type=style&index=0&id=5f65e37a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f65e37a",
  null
  
)

export default component.exports